import { Link } from "react-router-dom";
import { LintMood } from "./LintMood";

export function DemoCta() {
  return (
    <section className="relative overflow-hidden bg-navy py-20 text-cream sm:py-24" data-testid="demo-cta">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 sm:px-8 lg:grid-cols-[1.2fr_0.8fr]">
        <div className="max-w-xl">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-teal-bright">Interactive preview</p>
          <h2 className="font-display mt-3 text-3xl font-semibold tracking-tight sm:text-5xl">See what Lint sees.</h2>
          <p className="mt-4 text-base leading-relaxed text-cream/75 sm:text-lg">
            Sit beside Lint as he reviews Marketly: a sample marketplace with
            three repositories, architecture findings, security gaps and
            compliance checks.
          </p>
          <Link
            to="/demo"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-cream px-6 py-3.5 text-sm font-semibold text-navy transition-colors hover:bg-teal-bright"
            data-testid="demo-cta-link"
          >
            Explore Marketly with Lint
            <span aria-hidden className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
        </div>
        <LintMood
          from="deepDive"
          to="laptop"
          alt="Lint reviewing a project"
          say={["Let me take a closer look…", "This architecture will bottleneck at scale. Let me show you where."]}
          bubbleClass="max-w-[240px]"
          className="w-60 sm:w-72"
          testId="demo-cta-lint"
        />
      </div>
    </section>
  );
}
